import {createAsyncThunk} from "@reduxjs/toolkit";
import {USER_LOCALSTORAGE_KEY} from "../../../../../shared/const/localstorage";
import axios from "axios";
import {HomeworkListDataResponse} from "../../../types/student-info/studentsInfoHomeworksShema";
import {setHomeworkData} from "../../../slice/student-info/StudentInfoHomeworksSlice";
import {createRequestParams} from "../../../../../common/hook/create-request-params/createRequestParams";


interface StudentInfoParams {
    groupId: string | undefined;
    studentId: string | undefined;
    from?: string;
    to?: string;
    page?: number;
}

export const fetchStudentInfoHomeworks = createAsyncThunk(
    "student/fetchStudentHomeworks",
    async ({ groupId, studentId,from, to, page }: StudentInfoParams, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error("No token found in localStorage.");
            }
            const { token } = JSON.parse(authToken);

            const params = createRequestParams(from, to, page);

            const response = await axios.get<HomeworkListDataResponse>(
                `/api/groups/${groupId}/student-info/${studentId}/homeworks`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    params,
                }
            );

            if (!response.data) {
                throw new Error("Response data is empty");
            }

            if (response.data.success) {
                thunkAPI.dispatch(setHomeworkData(response.data.data));
            }

            return response.data;
        } catch (e) {
            return thunkAPI.rejectWithValue("error");
        }
    }
);